import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule } from '../button/button.module';
import { CheckboxesModule } from '../forms/checkboxes/checkboxes.module';
import { IconModule } from '../icon/icon.module';
import { ListItemComponent } from './list-item.component';
import { ListComponent } from './list.component';
import { ToggleModule } from '../toggle/toggle.module';

@NgModule({
  declarations: [ListItemComponent, ListComponent],
  imports: [
    CommonModule,
    ButtonModule,
    TranslocoModule,
    IconModule,
    CheckboxesModule,
    ToggleModule,
  ],
  exports: [ListItemComponent, ListComponent],
})
export class ListModule {}
